<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config.json";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {nguCanhModel} from "@/models/nguCanhModel";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Quản lý ngữ cảnh",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader ,  Multiselect },
  data() {
    return {
      title: "Quản lý ngữ cảnh",
      items: [
        {
          text: "Vai trò",
          href: "/vai-tro",
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: nguCanhModel.baseJson(),
      listRole: [],
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      totalCauHoi: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: 'STT', label: 'STT',
          class: "text-center td-sttt",
          tdClass: 'align-middle',
          thClass: 'hidden-sortable'
        },
        {
          key: "serviceCode",
          label: "Mã thủ tục",
          class: "td-mthutuc",
          thStyle: "text-align:center",
          thClass: 'hidden-sortable'
        },
        {
          key: "nguCanh",
          label: "Ngữ cảnh",
          thStyle: "text-align:center",
          thClass: 'hidden-sortable'
        },
        {
          key: "soLuong",
          label: "Số lượng",
          class: "text-center td-sl",
          thClass: 'hidden-sortable'
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: "text-center td-xl",
          thClass: 'hidden-sortable'
        }
      ],
      listLinhVuc : [],
      listDonVi : [],
      listMucDo: [],
      itemFilter: {
        MaThuTuc: null,
        ThuTuc: null,
        NguCanh : null,
        Level : null,
        Administration :null,
        Domain:null,
      },
    };
  },
  validations: {
    model: {
      thuTuc: {required},
      nguCanh: {required},
      serviceCode: {required},
      linhVuc : {required},
      donVi : {required},
    },
  },
  created() {
    this.getAllLinhVuc("ALL");
    this.getAllDonVi();
    this.getAllMucDo();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      }
    },
    showModal(status) {
      if (status == false) this.model = nguCanhModel.baseJson();
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    },
  },
  methods: {
    handleSearch() {
      this.$refs.tblList.refresh();
    },
    handleClear(){
      this.itemFilter = {
        ThuTuc: null,
        NguCanh : null,
        Level : null,
        Administration :null,
        Domain:null,
      } ;
    },
    async getAllLinhVuc(code) {
      await this.$store.dispatch("syncStore/getAllLinhVuc", code).then((res) => {
        this.listLinhVuc = res.data.data || [];
      })
    },
    async getAllDonVi() {
      await this.$store.dispatch("syncStore/getAllDonVi").then((res) => {
        this.listDonVi = res.data.data || [];
      })
    },
    async getAllMucDo() {
      await this.$store.dispatch("syncStore/getAllMucDo").then((res) => {
        this.listMucDo = res.data || [];
      })
    },

    async handleUpdate(id) {
      await this.$store.dispatch("nguCanhStore/getById", {id : id}).then((res) => {
        if (res.code === 0) {
          this.model = nguCanhModel.fromJson(res.data);
     //     console.log("LOG MODEL UPDATE ", this.model)
          this.showModal = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          this.$refs.tblList.refresh()
        }
      });
    },
    async handleDetail(id) {
      await this.$store.dispatch("nguCanhStore/getById", {id : id}).then((res) => {
        if (res.code === 0) {
          this.model = nguCanhModel.fromJson(res.data);
         // console.log("LOG MODEL DETAIL ", this.model)
          this.showDetail = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("nguCanhStore/delete", {id : this.model.id}).then((res) => {
          if (res.code === 0) {
            this.showDeleteModal = false;
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await this.$store.dispatch("nguCanhStore/update", this.model).then((res) => {
            if (res.code === 0) {
              this.showModal = false;
              this.$refs.tblList.refresh()
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          // Create model
          await this.$store.dispatch("nguCanhStore/create", nguCanhModel.fromJson(this.model)).then((res) => {
            if (res.code === 0) {
              this.showModal = false;
              this.$refs.tblList.refresh()
              this.model = {};
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    myProvider(ctx) {
      console.log("LOG NGU CANH ", this.itemFilter)
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        level: this.itemFilter.Level ? this.itemFilter.Level : null ,
        administration: this.itemFilter.Administration ? this.itemFilter.Administration : null,
        domain: this.itemFilter.Domain ? this.itemFilter.Domain : null ,
        thuTuc : this.itemFilter.ThuTuc ? this.itemFilter.ThuTuc : null,
        maThuTuc : this.itemFilter.MaThuTuc ? this.itemFilter.MaThuTuc : null,
        nguCanh : this.itemFilter.NguCanh ? this.itemFilter.NguCanh : null,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("nguCanhStore/getPagingParams", params)
        return promise.then(resp => {
    //      console.log("LOG DATA : ", resp.data.totalRows)
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.totalCauHoi = resp.data.soCauHoi
          this.numberOfElement = resp.data.data.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
    // todoFiltered(filteredItems) {
    //   // Trigger pagination to update the number of buttons/pages due to filtering
    //   this.todoTotalRows = filteredItems.length;
    //   this.todocurrentPage = 1;
    // }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="row">
                <div class="mb-3 col-lg-12">
                  <label>Mã thủ tục</label>
                  <input
                      v-model="itemFilter.MaThuTuc"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                      placeholder="Tìm kiếm theo nội dung thủ tục"
                  />
                </div>

                <div class="mb-3 col-lg-12">
                  <label>Nội dung thủ tục</label>
                  <input
                      v-model="itemFilter.ThuTuc"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                      placeholder="Tìm kiếm theo nội dung thủ tục"
                  />
                </div>

                <div class="mb-3 col-lg-12">
                  <label>Nội dung ngữ cảnh</label>
                  <input
                      v-model="itemFilter.NguCanh"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                      placeholder="Tìm kiếm theo nội dung ngữ cảnh"
                  />
                </div>

                <div class="mb-3 col-lg-4">
                  <label>Đơn vị quản lý</label>
                  <multiselect
                      v-model="itemFilter.Administration"
                      :options="listDonVi"
                      :multiple="false"
                      track-by="administrationCode"
                      class="helo"
                      selectLabel="Nhấn vào để chọn"
                      deselectLabel="Nhấn vào để xóa"
                      label="administrationName"
                      placeholder="Chọn cơ quan quản lý"
                  ></multiselect>
                </div>
                <div class="mb-3 col-lg-4">
                  <label>Lĩnh vực</label>
                  <multiselect
                      v-model="itemFilter.Domain"
                      :options="listLinhVuc"
                      :multiple="false"
                      class="helo"
                      selectLabel="Nhấn vào để chọn"
                      deselectLabel="Nhấn vào để xóa"
                      label="domainName"
                      placeholder="Chọn lĩnh vực"
                  ></multiselect>
                </div>
                <div class="mb-3 col-lg-4">
                  <label>Mức độ</label>
                  <multiselect
                      v-model="itemFilter.Level"
                      :options="listMucDo"
                      :multiple="false"
                      class="helo"
                      selectLabel="Nhấn vào để chọn"
                      deselectLabel="Nhấn vào để xóa"
                      label="name"
                      placeholder="Chọn mức độ"
                  ></multiselect>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <b-button variant=""
                            class="w-10 btn-search"
                            style="margin-right: 10px ; height: 40px ; width: 130px"
                            size="sm"
                            @click="handleSearch"
                  >
                    <i
                        class="bx bx-search font-size-16 align-middle me-2"
                    ></i>
                    Tìm kiếm
                  </b-button>
                  <b-button
                      class="w-10 btn-reset"
                      style="margin-right: 10px; height: 40px ; width: 130px"
                      size="sm"
                      @click="handleClear"
                  >
                    <i class="mdi mdi-replay font-size-16 align-middle me-2"></i>
                    Làm mới
                  </b-button>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <div class="text-sm-end">
                  <b-button type="button" class="btn-label bg-color mb-2 me-2" @click="showModal = true" size="sm"
                  >
                    <i class="mdi mdi-plus me-1 label-icon"></i> Thêm
                  </b-button>
                  <b-modal
                      v-model="showModal"
                      title="Thông tin ngữ cảnh"
                      title-class="text-black font-18"
                      body-class="p-3"
                      hide-footer
                      centered
                      no-close-on-backdrop
                      size="lg"
                  >
                    <form @submit.prevent="handleSubmit"
                          ref="formContainer">
                      <div class="row">
                        <div class="col-6">
                          <div class="mb-3">
                            <label class="text-left">Mã thủ tục</label>
                            <span style="color: red">&nbsp;*</span>
                            <input
                                id="ten"
                                v-model.trim="model.serviceCode"
                                class="form-control"
                                style="height: 50px;"
                                placeholder="Nhập mã thủ tục"
                                :class="{
                                'is-invalid':
                                  submitted && $v.model.serviceCode.$error,
                              }"
                            />
                            <div
                                v-if="submitted && !$v.model.serviceCode.required"
                                class="invalid-feedback"
                            >
                              Mã thủ tục không được để trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="mb-3">
                            <label class="text-left">Đơn vị</label>
                            <span style="color: red">&nbsp;*</span>
                            <multiselect
                                v-model ="model.donVi"
                                :options="listDonVi"
                                :multiple="false"
                                track-by="administrationCode"
                                class="helo"
                                selectLabel="Nhấn vào để chọn"
                                deselectLabel="Nhấn vào để xóa"
                                label="administrationName"
                                placeholder="Chọn cơ quan quản lý"
                                :class="{
                                'is-invalid':
                                  submitted && $v.model.donVi.$error,
                              }"
                            ></multiselect>
                            <div
                                v-if="submitted && !$v.model.donVi.required"
                                class="invalid-feedback"
                            >
                              Đơn vị không được để trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="mb-3">
                            <label class="text-left">Lĩnh vực</label>
                            <span style="color: red">&nbsp;*</span>
                            <multiselect
                                v-model ="model.linhVuc"
                                :options="listLinhVuc"
                                :multiple="false"
                                track-by="id"
                                class="helo"
                                selectLabel="Nhấn vào để chọn"
                                deselectLabel="Nhấn vào để xóa"
                                label="domainName"
                                placeholder="Chọn lĩnh vực"
                                :class="{
                                'is-invalid':
                                  submitted && $v.model.linhVuc.$error,
                              }"
                            ></multiselect>
                            <div
                                v-if="submitted && !$v.model.linhVuc.required"
                                class="invalid-feedback"
                            >
                              Lĩnh vực không được để trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="mb-3">
                            <label class="text-left">Mực độ</label>
                            <multiselect
                                v-model = "model.mucDo"
                                :options="listMucDo"
                                :multiple="false"
                                track-by="id"
                                class="helo"
                                selectLabel="Nhấn vào để chọn"
                                deselectLabel="Nhấn vào để xóa"
                                label="name"
                                placeholder="Chọn mức độ"
                            ></multiselect>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="text-left">Thủ tục</label>
                            <span style="color: red">&nbsp;*</span>
                            <textarea
                                v-model="model.thuTuc"
                                type="text"
                                min="0"
                                oninput="validity.valid||(value='');"
                                class="form-control"
                                rows="2"
                                placeholder="Nhập tên thủ tục"
                                :class="{
                                'is-invalid':
                                  submitted && $v.model.thuTuc.$error,
                              }"
                            />
                            <div
                                v-if="submitted && !$v.model.thuTuc.required"
                                class="invalid-feedback"
                            >
                              Thủ tục không được để trống.
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="text-left">Ngữ cảnh</label>
                            <span style="color: red">&nbsp;*</span>
                            <textarea
                                v-model="model.nguCanh"
                                type="text"
                                style="height: 100%;"
                                class="form-control"
                                rows="4"
                                placeholder="Nhập ngữ cảnh"
                                :class="{
                                'is-invalid':
                                  submitted && $v.model.nguCanh.$error,
                              }"
                            />
                            <div
                                v-if="submitted && !$v.model.nguCanh.required"
                                class="invalid-feedback"
                            >
                              Ngữ cảnh không được để trống.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-2 mt-3">
                        <b-button variant="light" @click="showModal = false">
                          Đóng
                        </b-button>
                        <b-button type="submit" class="ms-1 bg-color">
                          Lưu
                        </b-button>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: -20px">
              <div class="col-12">
                <div class="row mt-4">
                  <div class="col-md-9">
                    <div>Hiện có tổng
                      <span style="color: #9f0220; font-weight:bold">{{this.totalRows}}</span>
                      ngữ cảnh trong đó có
                      <span style="color: #9f0220; font-weight:bold">{{this.totalCauHoi}} </span>
                      câu hỏi và
                      <span style="color: #9f0220; font-weight:bold">{{this.totalCauHoi}}  </span>
                      câu trả lời
                    </div>

                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                        class="col-sm-12 d-flex justify-content-left align-items-center"
                    >
                      <div
                          id="tickets-table_length"
                          class="dataTables_length m-1"
                          style="
                        display: flex;
                        justify-content: left;
                        align-items: center;
                      "
                      >
                        <div class="me-1" >Hiển thị </div>
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                            style="width: 70px"
                        ></b-form-select
                        >&nbsp;
                        <div style="width: 100px"> dòng</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive-sm">
                  <b-table
                      class="datatables table-size"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(serviceCode)="data">
                      <span
                          class="badge-soft-primary rounded-pill font-size-12 fw-bolder" v-if ="data.item.serviceCode">
                        {{ data.item.serviceCode}}
                      </span>
                      <div class="row title-decs">
                          <span class="col-md-12 row mt-2" v-if ="data.item.linhVuc">
                            <div class="col-md-5 x-1" >
                              Lĩnh vực:
                            </div>
                            <div class="col-md-7">
                              <span class="badge-linhvuc badge rounded-pill font-size-10 fw-bolder" v-if ="data.item.linhVuc">
                                {{ data.item.linhVuc.domainName }}
                              </span>
                            </div>
                          </span>
                          <span class="col-md-12 mt-2">
                            {{ data.item.thuTuc }}
                          </span>
                        </div>
                    </template>
                    <template v-slot:cell(nguCanh)="data">
                      <span class="nguCanh">
                          {{ data.item.nguCanh }}
                      </span>
                    </template>
                    <template v-slot:cell(soLuong)="data">
                      <router-link :to="{ name: 'DANH SÁCH BỘ CÂU HỎI - TRẢ LỜI',
                      query: { data: JSON.stringify(data.item)}}">
                        <b-button
                            variant="outline-danger btn-sm"
                            class="bg-color cs-color"
                            size="sm"
                        >{{ data.item.soLuong}}
                        </b-button>
                      </router-link>
                    </template>
                    <template v-slot:cell(process)="data">

                      <button
                          type="button"
                          size="sm"
                          class="btn btn-outline btn-sm btn-xl"
                          data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                          v-on:click="handleUpdate(data.item.id)">
                        <i class="mdi mdi-pencil text-success me-1 fs-15"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-outline btn-sm btn-xl"
                          data-toggle="tooltip" data-placement="bottom" title="Xóa"
                          v-on:click="handleShowDeleteModal(data.item.id)">
                        <i class="mdi mdi-delete text-danger me-1 fs-15"></i>
                      </button>
                    </template>
                    <template v-slot:cell(ten)="data">&nbsp;&nbsp;
                      {{ data.item.ten }}
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <b-col>
                    <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                  </b-col>
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="font-18"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <button v-b-modal.modal-close_visit
                    class="btn btn-outline-info m-1"
                    v-on:click="showDeleteModal = false">
              Đóng
            </button>
            <button v-b-modal.modal-close_visit
                    class="btn btn-danger btn m-1"
                    v-on:click="handleDelete">
              Xóa
            </button>
          </template>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<style>

.nguCanh{
  text-align: justify;
  display: -webkit-box !important;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.btn-search, .btn-reset{
  background-color: #204b03 !important;
  font-size: 15px !important;
}
.fs-10{
  font-size: 10px;
}

.td-sttt{
  width: 4%;
}
.td-mthutuc{
  width: 35%;
}
.td-thutuc{
  width: 30%;
}

.td-sl{
  width: 8%;
}
.td-xl{
  width: 8%;
}

.badge-linhvuc{
  color: #204b03;
  border-radius: 5px;
  background-color: #204b0347;
  padding: 5px;
}

.badge-soft-primary{
  padding: 5px;
}
.badge-danger{
  color: #f44336;
  border-radius: 5px;
  background-color: #f4433644;
}
.btn-xl{
  padding: 0px;
}
.multiselect__option--highlight, .multiselect__option--highlight:after{
  background-color: #204b03 !important;
}
</style>
